// The address of the current page to come back to after logging in. Its own backUrl is dropped, so values never nest.
export function currentPageBackUrl(): string {
    const { pathname, search } = window.location;
    const query = new URLSearchParams(search);
    if (!query.has("backUrl")) {
        return pathname + search;
    }

    query.delete("backUrl");
    const queryString = query.toString();

    return pathname + (queryString ? `?${queryString}` : "");
}

// Slashes stay literal to keep the address readable; every auth link carries the backUrl in this one shape.
export function encodeBackUrl(backUrl: string): string {
    return encodeURIComponent(backUrl).replace(/%2F/g, "/");
}
